module.exports = __webpack_public_path__ + "img/avatar6.f2757e83.png";